import { render, staticRenderFns } from "./elementVideoBanner.vue?vue&type=template&id=3e168727&scoped=true"
import script from "./elementVideoBanner.vue?vue&type=script&lang=ts"
export * from "./elementVideoBanner.vue?vue&type=script&lang=ts"
import style0 from "./elementVideoBanner.vue?vue&type=style&index=0&id=3e168727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e168727",
  null
  
)

export default component.exports